const hasNegativePercentage = percentage => {
  if (typeof percentage !== 'number' || !percentage) return false;

  return percentage < 0;
};

export default hasNegativePercentage;
